import Airtable from 'airtable'

export default function useAirtableBase(baseID) {
  const airtableBase = new Airtable({ apiKey: process.env.GATSBY_AIRTABLE_API_KEY }).base(baseID)
  return airtableBase
}
